import { createAction } from '../../utils/redux/createAction';

const actionsScope = 'health-board/validaiton';

export const HEALTH_BOARD_TYPES = {
  TOGGLE_VALIDATE: `${actionsScope}/toogle-validation`,
};

export const healthBoardActions = {
  toggleValidation: createAction(HEALTH_BOARD_TYPES.TOGGLE_VALIDATE),
};

const initalState = {
  validating: true,
};

export default (state = initalState, { type, payload }) => {
  switch (type) {
    case HEALTH_BOARD_TYPES.TOGGLE_VALIDATE: {
      return {
        ...state,
        validating: payload,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/root.js